// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleWrapper_root__Q8ty6","standard":"ArticleWrapper_standard__178wv"};